export default {
  'pages.workbench.defaultUser': 'teammate',
  'pages.workbench.enterpriseWorkspace': 'Enterprise workspace',
  'pages.workbench.welcome': 'Welcome back, {name}',
  'pages.workbench.welcomeDescription':
    'Connect apps, basic services, and operations. Start your day here.',
  'pages.workbench.refresh': 'Refresh workspace',
  'pages.workbench.openAppCenter': 'Open Applications',
  'pages.workbench.partialError':
    'Some data could not be loaded. Available content is shown.',
  'pages.workbench.retry': 'Reload',
  'pages.workbench.overview': 'Workspace overview',
  'pages.workbench.installedApps': 'Enabled apps',
  'pages.workbench.availableToTeam':
    'Business apps enabled for your enterprise',
  'pages.workbench.myApps': 'My apps',
  'pages.workbench.myAppsDescription':
    'Apps enabled for your enterprise, ready when you are',
  'pages.workbench.viewAll': 'View all',
  'pages.workbench.enabled': 'Enabled',
  'pages.workbench.openApp': 'Open {name} (new window)',
  'pages.workbench.viewApp': 'View {name}',
  'pages.workbench.noApps': 'Enable your first enterprise app',
  'pages.workbench.noAppsDescription':
    'Discover tools for your team in the App Marketplace and simplify collaboration.',
  'pages.workbench.appsError': 'The app list is temporarily unavailable',
  'pages.workbench.retryDescription':
    'Reload, or open the relevant center to view the data.',
  'pages.workbench.browseMarket': 'Browse App Marketplace',
  'pages.workbench.resourceOverview': 'Resource overview',
  'pages.workbench.resourceOverviewDescription':
    'Cluster resource usage in this workspace',
  'pages.workbench.cpu': 'CPU',
  'pages.workbench.memory': 'Memory',
  'pages.workbench.cores': 'cores',
  'pages.workbench.gib': 'GiB',
  'pages.workbench.notConnected': 'Not connected',
  'pages.workbench.unavailable': 'No data available',
  'pages.workbench.resourceUsage': '{used} / {total} {unit} used',
  'pages.workbench.connectClusterDescription':
    'Connect your enterprise cluster to view resource usage',
  'pages.workbench.openMonitoring': 'View resource monitoring',
  'pages.workbench.guideTitle': 'Explore more possibilities',
  'pages.workbench.guideDescription':
    'Find the right apps and capabilities for your team.',
  'pages.workbench.guide.apps': 'Discover business apps',
  'pages.workbench.guide.appsDescription':
    'Browse enterprise apps and expand your team’s toolkit',
  'pages.workbench.footer': 'Enterprise Digital & AI Operating System',
  'pages.workbench.deployments': 'My deployments',
  'pages.workbench.deploymentsInCluster': 'Services running in your cluster',
  'pages.workbench.clusterNodes': 'Cluster nodes',
  'pages.workbench.readyNodes': 'Nodes ready',
  'pages.workbench.runningPods': 'Running pods',
  'pages.workbench.podsInCluster': 'Pods running in the cluster',
  'pages.workbench.deploymentsPanel': 'My deployments',
  'pages.workbench.deploymentsPanelDescription':
    'Apps and services deployed in your enterprise cluster',
  'pages.workbench.allDeployments': 'All deployments',
  'pages.workbench.noDeployments': 'No deployments yet',
  'pages.workbench.noDeploymentsDescription':
    'Deploy in one click from a deployment template or launch custom container images.',
  'pages.workbench.deploymentsError': 'Deployments are temporarily unavailable',
  'pages.workbench.openAppStore': 'Open Deployment Templates',
  'pages.workbench.guide.appStore': 'Deploy cloud native apps',
  'pages.workbench.guide.appStoreDescription':
    'Deploy databases, devops tools, and custom containers in one click',
};
